"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BinaryPack = require("peerjs-js-binarypack");
const supports_1 = require("./supports");
const DEFAULT_CONFIG = {
    iceServers: [
        { urls: "stun:stun.l.google.com:19302" },
        { urls: "turn:0.peerjs.com:3478", username: "peerjs", credential: "peerjsp" }
    ],
    sdpSemantics: "unified-plan"
};
exports.util = new class {
    constructor() {
        this.CLOUD_HOST = "0.peerjs.com";
        this.CLOUD_PORT = 443;
        // Browsers that need chunking:
        this.chunkedBrowsers = { Chrome: 1, chrome: 1 };
        this.chunkedMTU = 16300; // The original 60000 bytes setting does not work when sending data from Firefox to Chrome, which is "cut off" after 16384 bytes and delivered individually.
        // Returns browser-agnostic default config
        this.defaultConfig = DEFAULT_CONFIG;
        this.browser = supports_1.Supports.getBrowser();
        this.browserVersion = supports_1.Supports.getVersion();
        // Lists which features are supported
        this.supports = (function () {
            const supported = {
                browser: supports_1.Supports.isBrowserSupported(),
                webRTC: supports_1.Supports.isWebRTCSupported(),
                audioVideo: false,
                data: false,
                binaryBlob: false,
                reliable: false,
            };
            if (!supported.webRTC)
                return supported;
            let pc;
            try {
                pc = new RTCPeerConnection(DEFAULT_CONFIG);
                supported.audioVideo = true;
                let dc;
                try {
                    dc = pc.createDataChannel("_PEERJSTEST", { ordered: true });
                    supported.data = true;
                    supported.reliable = !!dc.ordered;
                    // Binary test
                    try {
                        dc.binaryType = "blob";
                        supported.binaryBlob = !supports_1.Supports.isIOS;
                    }
                    catch (e) {
                    }
                }
                catch (e) {
                }
                finally {
                    if (dc) {
                        dc.close();
                    }
                }
            }
            catch (e) {
            }
            finally {
                if (pc) {
                    pc.close();
                }
            }
            return supported;
        })();
        this.pack = BinaryPack.pack;
        this.unpack = BinaryPack.unpack;
        // Binary stuff
        this._dataCount = 1;
    }
    noop() { }
    // Ensure alphanumeric ids
    validateId(id) {
        // Allow empty ids
        return !id || /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/.test(id);
    }
    chunk(blob) {
        const chunks = [];
        const size = blob.size;
        const total = Math.ceil(size / exports.util.chunkedMTU);
        let index = 0;
        let start = 0;
        while (start < size) {
            const end = Math.min(size, start + exports.util.chunkedMTU);
            const b = blob.slice(start, end);
            const chunk = {
                __peerData: this._dataCount,
                n: index,
                data: b,
                total,
            };
            chunks.push(chunk);
            start = end;
            index++;
        }
        this._dataCount++;
        return chunks;
    }
    blobToArrayBuffer(blob, cb) {
        const fr = new FileReader();
        fr.onload = function (evt) {
            if (evt.target) {
                cb(evt.target.result);
            }
        };
        fr.readAsArrayBuffer(blob);
        return fr;
    }
    binaryStringToArrayBuffer(binary) {
        const byteArray = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            byteArray[i] = binary.charCodeAt(i) & 0xff;
        }
        return byteArray.buffer;
    }
    randomToken() {
        return Math.random()
            .toString(36)
            .substr(2);
    }
    isSecure() {
        return location.protocol === "https:";
    }
};
